import { render, staticRenderFns } from "./client-title.vue?vue&type=template&id=7bd54f75&scoped=true"
import script from "./client-title.vue?vue&type=script&lang=js"
export * from "./client-title.vue?vue&type=script&lang=js"
import style0 from "./client-title.vue?vue&type=style&index=0&id=7bd54f75&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd54f75",
  null
  
)

export default component.exports